import { FC, MouseEvent } from 'react';
import { Typography, Fab, Box, useTheme } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useStyles } from './styles';
interface BasicContainerProps {
  title?: string;
  onAdd?: (event: MouseEvent) => void;
}

export const BasicContainer: FC<BasicContainerProps> = ({
  title,
  children,
  onAdd,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div className={classes.fieldGroup}>
      {title && (
        <Box
          sx={{
            display: 'flex',
            position: 'absolute',
            top: -17,
            backgroundColor: theme.palette.common.white,
          }}
        >
          <Typography
            sx={{
              margin: '0 10px',
            }}
            variant="h6"
          >
            {title}
          </Typography>
        </Box>
      )}
      {children}
      {onAdd && (
        <Fab
          size="small"
          color="secondary"
          aria-label="Add"
          className={classes.addBtn}
          onClick={onAdd}
        >
          <Add />
        </Fab>
      )}
    </div>
  );
};
